<form [formGroup]="altresObservacionsForm">
  <div class="apartats" *ngIf="valoracions">
    <div class="apartat">
      <label>{{valoracions[8].preguntes[0].descripcio}}</label>
      <app-ajuda id="ajuda_factors" titol="Factors protectors/resiliència">
        <ul>
          <li><strong>Factors protectors</strong> són aquelles característiques dels progenitors o guardadors i/o de l'entorn familiar i social de l'infant/adolescent que poden, en un moment donat, evitar que es produeixi una situació de maltractament i/o minvar-ne els seus efectes.</li>
          <li><strong>Els factors de resiliència</strong> es refereixen a característiques del mateix infant/adolescent que fan que, en cas de produir-se un maltractament, l'infant sigui més capa´de superar-ne els efectes.</li>
        </ul>
        Es pot fer una selecció múltiple marcant diverses opcions:
        
        <ul>
          <li>Per seleccionar elements no correlatius: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu seleccionar.</li>
          <li>Per seleccionar elements correlatius, mantenir premuda la tecla Shift. Clicar el primer element i després l'últim.</li>
          <li>Per desseleccionar: mantenir premuda la tecla Ctrl i fer clic en els elements que desitgeu desseleccionar.</li>
        </ul>
      </app-ajuda>
      <div>
        <select formControlName="factorsPregunta" multiple [size]="valoracions[8].preguntes[0].respostes.length">
          <option *ngFor="let resposta of valoracions[8].preguntes[0].respostes" [value]="resposta.id">{{resposta.descripcio}}</option>
        </select>
      </div>
    </div>
    <div class="apartat">
      <label>Altres factors i observacions generals del cas:</label>
      <app-ajuda id="ajuda_altres_factors" titol="Altres factors i observacions">
        Afegiu tots aquells altres detalls del cas que considereu rellevants per a la seva millor valoració. En el cas que estigueu fent una simulació, les observacions no seran tingudes en compte a l'hora de fer una recomanació, atès que són un element per a la millor valoració de casos reals per part dels equips competents que rebin la comunicació
      </app-ajuda>
      <div>
        <textarea formControlName="altresFactorsObservacions" rows="6" cols="20"></textarea>
      </div>
    </div>
  </div>
</form>

<div class="button-bar">
  <button class="main" (click)="goToPrevStep()"><i class="fas fa-angle-left prev" aria-hidden></i> {{'globals.anterior' | translate}}</button>
  <button class="main" (click)="goToNextStep()">{{'globals.seguent' | translate}} <i class="fas fa-angle-right next" aria-hidden></i></button>
</div>